const resource = '/shop-api/klaviyo'

export default (ctx, $axios) => ({
  subscribe (payload) {
    return $axios.$post(`${resource}/subscribe`, payload)
  },
  currentUserEmailMarketingSubscriptionStatus (authToken) {
    return $axios.$post(`${resource}/current-user/email-marketing-subscription-status`, null, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
  },
  track (eventName, properties, email = null, correlationId = null) {
    if (process.client && sessionStorage.getItem('klaviyoTrackingAllowed') !== 'true') {
      return Promise.resolve()
    }

    const payload = {
      EventName: eventName,
      Properties: properties,
      Email: email,
      CorrelationId: correlationId
    }

    return $axios.$post(`${resource}/track`, payload)
  }
})
